// src/systems/audioSystem.ts — Placeholder audio Fase 2 (sin assets con copyright)
// Genera sonidos con WebAudio API (beep procedural) o queda en silencio si el usuario lo desactiva.

export type MusicKey = 'villa'|'ruta'|'interior'|'tienda'|'centro'|'none';

export class AudioSystem {
  private ctx: AudioContext | null = null;
  private enabled = true;
  private volume = 0.6;
  private currentMusic: MusicKey = 'none';

  constructor() {
    try {
      const v = localStorage.getItem('aetheria:audio:muted');
      if (v==='1') this.enabled=false;
    } catch {}
  }

  private ensureCtx(): AudioContext | null {
    if (!this.enabled) return null;
    if (this.ctx) return this.ctx;
    try { this.ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)(); }
    catch { return null; }
    return this.ctx;
  }

  setVolume(v:number): void { this.volume = Math.max(0, Math.min(1, v)); }
  setMuted(m:boolean): void {
    this.enabled = !m;
    try { localStorage.setItem('aetheria:audio:muted', m?'1':'0'); } catch {}
  }

  playSfx(kind: 'step'|'interact'|'warp'|'dialog'|'menu'): void {
    if (!this.enabled) return;
    const ctx = this.ensureCtx(); if (!ctx) return;
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    const now = ctx.currentTime;
    switch(kind){
      case 'step': o.frequency.value=180; g.gain.setValueAtTime(0.08*this.volume, now); g.gain.exponentialRampToValueAtTime(0.001, now+0.12); o.start(now); o.stop(now+0.12); break;
      case 'interact': o.frequency.value=620; g.gain.setValueAtTime(0.12*this.volume, now); g.gain.exponentialRampToValueAtTime(0.001, now+0.18); o.start(now); o.stop(now+0.18); break;
      case 'warp': o.frequency.value=440; g.gain.setValueAtTime(0.15*this.volume, now); o.frequency.linearRampToValueAtTime(880, now+0.35); g.gain.exponentialRampToValueAtTime(0.001, now+0.4); o.start(now); o.stop(now+0.4); break;
      case 'dialog': o.frequency.value=900; g.gain.setValueAtTime(0.06*this.volume, now); g.gain.exponentialRampToValueAtTime(0.001, now+0.08); o.start(now); o.stop(now+0.08); break;
      case 'menu': o.frequency.value=300; g.gain.setValueAtTime(0.09*this.volume, now); g.gain.exponentialRampToValueAtTime(0.001, now+0.14); o.start(now); o.stop(now+0.14); break;
    }
  }

  // Música: por ahora solo cambia el label y hace un drone suave para demo
  playMusic(key: MusicKey): void {
    if (this.currentMusic===key) return;
    this.currentMusic = key;
    // No drone automático para no molestar; solo log
    console.info(`[Aetheria Audio] ♪ ${key}`);
  }

  getCurrent(): MusicKey { return this.currentMusic; }
}
